const ACTION = {
    UPDATE_ID_NUMBER: 'UPDATE_ID_NUMBER',
    UPDATE_ID_NUMBER_ERROR_TEXT: ' UPDATE_ID_NUMBER_ERROR_TEXT',
}

export default ACTION;